// // import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
// // import {
// //   ArrowBack,
// //   NotificationsNoneRounded,
// //   SettingsOutlined,
// // } from "@mui/icons-material";
// // import { useNavigate } from "react-router-dom";
// // import { ROUTES } from "../constants/consts";

// // // Ortak buton stili
// // const iconBtnSx = {
// //   color: "#fff",
// //   backgroundColor: "rgba(255,255,255,0.12)",
// //   backdropFilter: "blur(8px)",
// //   "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
// // };

// // export default function CustomAppBar({
// //   title,
// //   subtitle,
// //   isNotHome = false,
// //   extraActions,
// //   hideNotifications = false,
// //   hideSettings = false,
// // }) {
// //   const navigate = useNavigate();

// //   return (
// //     <AppBar
// //       position="fixed"
// //       // position="static"
// //       elevation={0}
// //       sx={{
// //         background: "transparent",
// //         boxShadow: "none",
// //         color: "#fff",
// //       }}
// //     >
// //       <Toolbar
// //         sx={{
// //           position: "relative",
// //           gap: 0.5,
// //           minHeight: { xs: 56, sm: 64 },
// //         }}
// //       >
// //         {/* SOL: Geri butonu (sadece alt sayfalarda) */}
// //         {isNotHome && (
// //           <IconButton
// //             edge="start"
// //             onClick={() => navigate(-1)}
// //             title="Geri"
// //             sx={{ color: "#fff", flexShrink: 0, mr: 0.5 }}
// //           >
// //             <ArrowBack />
// //           </IconButton>
// //         )}

// //         {/* ORTA-SOL: Başlık + subtitle */}
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             flexGrow: 1,
// //             minWidth: 0,
// //           }}
// //         >
// //           <Typography
// //             variant="h6"
// //             fontWeight={700}
// //             noWrap
// //             sx={{ lineHeight: 1.2 }}
// //           >
// //             {title}
// //           </Typography>
// //           {subtitle && (
// //             <Typography
// //               variant="body2"
// //               noWrap
// //               sx={{ color: "rgba(255,255,255,0.75)", fontSize: 12.5 }}
// //             >
// //               {subtitle}
// //             </Typography>
// //           )}
// //         </Box>

// //         {/* ORTADA: Logo (sadece alt sayfalarda) — absolute konum */}
// //         {isNotHome && (
// //           <Box
// //             component="img"
// //             src="/images/logo2.png"
// //             alt="Nortek"
// //             sx={{
// //               position: "absolute",
// //               left: "50%",
// //               top: "50%",
// //               transform: "translate(-50%, -50%)",
// //               height: { xs: 24, sm: 32 },
// //               width: "auto",
// //               maxWidth: { xs: 90, sm: 140 },
// //               objectFit: "contain",
// //               pointerEvents: "none",
// //               display: { xs: "none", sm: "block" }, // mobilde gizle
// //               filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.20))",
// //             }}
// //           />
// //         )}

// //         {/* SAĞ: Sayfaya özel aksiyonlar + bildirim + ayar */}
// //         {extraActions}

// //         {!hideNotifications && (
// //           <IconButton
// //             onClick={() => navigate(ROUTES.CUSTOMER_NOTIFICATIONS)}
// //             title="Duyurular"
// //             sx={{ ...iconBtnSx, mr: 0.5 }}
// //           >
// //             <NotificationsNoneRounded />
// //           </IconButton>
// //         )}

// //         {!hideSettings && (
// //           <IconButton
// //             onClick={() => navigate(ROUTES.CUSTOMER_SETTINGS)}
// //             title="Ayarlar"
// //             sx={{ ...iconBtnSx, mr: 0.5 }}
// //           >
// //             <SettingsOutlined />
// //           </IconButton>
// //         )}
// //       </Toolbar>
// //     </AppBar>
// //   );
// // }
// import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
// import {
//   ArrowBack,
//   NotificationsNoneRounded,
//   SettingsOutlined,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import { keyframes } from "@mui/system";
// import { ROUTES } from "../constants/consts";

// // Header yukarıdan kayarak insin
// const slideDown = keyframes`
//   from { opacity: 0; transform: translateY(-24px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// const iconBtnSx = {
//   color: "#fff",
//   backgroundColor: "rgba(255,255,255,0.12)",
//   backdropFilter: "blur(8px)",
//   transition: "transform 0.2s ease, background-color 0.2s ease",
//   "&:hover": {
//     backgroundColor: "rgba(255,255,255,0.22)",
//     transform: "scale(1.08)",
//   },
//   "&:active": { transform: "scale(0.92)" },
// };

// export default function CustomAppBar({
//   title,
//   subtitle,
//   isNotHome = false,
//   extraActions,
//   hideNotifications = false,
//   hideSettings = false,
// }) {
//   const navigate = useNavigate();

//   return (
//     <AppBar
//       position="fixed"
//       elevation={0}
//       sx={{
//         background: "transparent",
//         boxShadow: "none",
//         color: "#fff",
//         animation: `${slideDown} 0.45s cubic-bezier(0.22, 1, 0.36, 1) both`,
//       }}
//     >
//       <Toolbar
//         sx={{
//           position: "relative",
//           gap: 0.5,
//           minHeight: { xs: 56, sm: 64 },
//         }}
//       >
//         {/* SOL: Geri butonu */}
//         {isNotHome && (
//           <IconButton
//             edge="start"
//             onClick={() => navigate(-1)}
//             title="Geri"
//             sx={{
//               color: "#fff",
//               flexShrink: 0,
//               mr: 0.5,
//               transition: "transform 0.2s ease",
//               "&:hover": { transform: "translateX(-3px)" },
//             }}
//           >
//             <ArrowBack />
//           </IconButton>
//         )}

//         {/* ORTA-SOL: Başlık + subtitle */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             flexGrow: 1,
//             minWidth: 0,
//           }}
//         >
//           <Typography
//             variant="h6"
//             fontWeight={700}
//             noWrap
//             sx={{ lineHeight: 1.2 }}
//           >
//             {title}
//           </Typography>
//           {subtitle && (
//             <Typography
//               variant="body2"
//               noWrap
//               sx={{ color: "rgba(255,255,255,0.75)", fontSize: 12.5 }}
//             >
//               {subtitle}
//             </Typography>
//           )}
//         </Box>

//         {/* ORTADA: Logo */}
//         {isNotHome && (
//           <Box
//             component="img"
//             src="/images/logo2.png"
//             alt="Nortek"
//             sx={{
//               position: "absolute",
//               left: "50%",
//               top: "50%",
//               transform: "translate(-50%, -50%)",
//               height: { xs: 24, sm: 32 },
//               width: "auto",
//               maxWidth: { xs: 90, sm: 140 },
//               objectFit: "contain",
//               pointerEvents: "none",
//               display: { xs: "none", sm: "block" },
//               filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.20))",
//               animation: `${slideDown} 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both`,
//             }}
//           />
//         )}

//         {extraActions}

//         {!hideNotifications && (
//           <IconButton
//             onClick={() => navigate(ROUTES.CUSTOMER_NOTIFICATIONS)}
//             title="Duyurular"
//             sx={{ ...iconBtnSx, mr: 0.5 }}
//           >
//             <NotificationsNoneRounded />
//           </IconButton>
//         )}

//         {!hideSettings && (
//           <IconButton
//             onClick={() => navigate(ROUTES.CUSTOMER_SETTINGS)}
//             title="Ayarlar"
//             sx={{ ...iconBtnSx, mr: 0.5 }}
//           >
//             <SettingsOutlined />
//           </IconButton>
//         )}
//       </Toolbar>
//     </AppBar>
//   );
// }
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import {
  ArrowBack,
  NotificationsNoneRounded,
  SettingsOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { keyframes } from "@mui/system";
import { ROUTES } from "../constants/consts";

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const iconBtnSx = {
  color: "#fff",
  backgroundColor: "rgba(255,255,255,0.12)",
  backdropFilter: "blur(8px)",
  transition: "transform 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.22)",
    transform: "scale(1.08)",
  },
  "&:active": { transform: "scale(0.92)" },
};

export default function CustomAppBar({
  title,
  subtitle,
  isNotHome = false,
  extraActions,
  hideNotifications = false,
  hideSettings = false,
}) {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        // Hafif koyu degrade + alt kenar çizgisi → "oturmuş" görünüm
        background:
          "linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.04) 100%)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        borderBottom: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
        color: "#fff",
        animation: `${slideDown} 0.45s cubic-bezier(0.22, 1, 0.36, 1) both`,
      }}
    >
      <Toolbar
        sx={{
          position: "relative",
          // gap: 0.5,
          // ↓↓↓ Kalınlık burada: xs 72px, sm+ 84px
          // minHeight: { xs: 72, sm: 84 },
          px: { xs: 1.5, sm: 2.5 },
        }}
      >
        {/* SOL: Geri butonu */}
        {isNotHome && (
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            title="Geri"
            sx={{
              color: "#fff",
              flexShrink: 0,
              mr: 0.5,
              transition: "transform 0.2s ease",
              "&:hover": { transform: "translateX(-3px)" },
            }}
          >
            <ArrowBack />
          </IconButton>
        )}

        {/* ORTA-SOL: Başlık + subtitle */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          <Typography
            variant="h6"
            fontWeight={700}
            noWrap
            sx={{ lineHeight: 1.2, fontSize: { xs: 18, sm: 20 } }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              noWrap
              sx={{ color: "rgba(255,255,255,0.75)", fontSize: 12.5, mt: 0.25 }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {/* ORTADA: Logo */}
        {/* {isNotHome && ( */}
        <Box
          component="img"
          src="/images/logo2.png"
          alt="Nortek"
          sx={{
            position: "absolute",
            left: "45%",
            top: "25%",
            transform: "translate(-50%, -50%)",
            height: { xs: 28, sm: 36 }, // ← biraz büyüdü
            width: "auto",
            maxWidth: { xs: 100, sm: 160 },
            objectFit: "contain",
            pointerEvents: "none",
            display: { xs: "none", sm: "block" },
            filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.20))",
            animation: `${slideDown} 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both`,
          }}
        />
        {/* )} */}

        {extraActions}

        {!hideNotifications && (
          <IconButton
            onClick={() => navigate(ROUTES.CUSTOMER_NOTIFICATIONS)}
            title="Duyurular"
            sx={{ ...iconBtnSx, mr: 0.5 }}
          >
            <NotificationsNoneRounded />
          </IconButton>
        )}

        {!hideSettings && (
          <IconButton
            onClick={() => navigate(ROUTES.CUSTOMER_SETTINGS)}
            title="Ayarlar"
            sx={{ ...iconBtnSx, mr: 0.5 }}
          >
            <SettingsOutlined />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}
